import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
  applicationDeadlineCopy: {
    id: 'JobOfferCard.applicationDeadlineCopy',
    defaultMessage: 'Application deadline:',
    description: 'Application deadline copy',
  },
});
